import { IconButton, Slider } from "@radix-ui/themes";
import { updateZoom } from "@/entities/player";
import { useAppDispatch, useAppSelector } from "@/app/appStore";
import { MagnifierMinusIcon, MagnifierPlusIcon } from "@/assets/icons";

export function ZoomSlider() {
  const ZOOM_STEP = 0.05;
  const zoomLevel = useAppSelector((state) => state.player.zoom);
  const dispatch = useAppDispatch();

  const onValueChange = (value: number) => {
    dispatch(updateZoom(value));
  };

  return (
    <>
      <IconButton
        variant="ghost"
        color="gray"
        size="2"
        onClick={() => {
          const newZoom = Math.max(zoomLevel - ZOOM_STEP, 0);
          if (newZoom < zoomLevel) {
            onValueChange(newZoom);
          }
        }}
      >
        <MagnifierMinusIcon className="text-brand-gray-200" />
      </IconButton>
      <Slider
        className="relative flex items-center select-none touch-none max-w-[200px] h-5"
        defaultValue={[25]}
        max={1}
        min={0}
        step={ZOOM_STEP}
        color="gray"
        highContrast
        size="1"
        value={[zoomLevel]}
        onValueChange={([value]) => {
          onValueChange(value);
        }}
        onKeyDown={(e) => {
          e.preventDefault();
        }}
        onPointerUp={(e) => {
          (e.target as HTMLElement).blur();
        }}
      />

      <IconButton
        variant="ghost"
        color="gray"
        size="2"
        onClick={() => {
          const newZoom = Math.min(zoomLevel + ZOOM_STEP, 1);
          if (newZoom > zoomLevel) {
            onValueChange(newZoom);
          }
        }}
      >
        <MagnifierPlusIcon className="text-brand-gray-200" />
      </IconButton>
    </>
  );
}
